<template>
  <div>
    <DataTable 
      :value="permissions"
      groupRowsBy="permission.permissionType" rowGroupMode="subheader"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="100"
      :rowHover="true"
      :selection.sync="selectedRows"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} permissions"
      :scrollable="true" scrollHeight="400px"
    >
      <template #empty> No permissions found. </template>
      <template #loading> Loading permissions data. Please wait. </template>
      <template #groupheader="slotProps">
          <h4 class="image-text">{{slotProps.data.permission.permissionType}}</h4>
      </template>
      
      <Column
        field="permission.permissionType"
        header="Type"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.permission && slotProps.data.permission.permissionType ? slotProps.data.permission.permissionType : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="permission.permissionDesc"
        header="Description"
        headerStyle="width: 22em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.permission && slotProps.data.permission.permissionDesc ? slotProps.data.permission.permissionDesc : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="permission.fields"
        header="Locked Fields"
        headerStyle="width: 12em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.permission && slotProps.data.permission.fields ? slotProps.data.permission.fields : '' }}
          </div>
        </template>
      </Column>
      <Column
          field="permissionLevel"
          header="Current Permission"
          headerStyle="width: 12em;"
          filterField="levelName"
        >
          <template #body="slotProps">
            <span 
              :class="'ignore pointer badge ' + permissionLevels[slotProps.data.permissionLevel].colourCode" 
            >
              {{ permissionLevels[slotProps.data.permissionLevel].levelName }}
            </span>
          </template>
      </Column>
      <Column
          header="Update Permission To"
          headerStyle="width: 12em;"
          filterField="levelName"
        >
          <template #body="slotProps">
            <span v-if="updatePermissions.length !== 0"
              v-on:click="changeLevel(slotProps.data, $event)"
              :class="'ignore pointer badge ' + permissionLevels[getUpdatedPermissionLevel(slotProps.data.id)].colourCode" 
            >
              {{ permissionLevels[getUpdatedPermissionLevel(slotProps.data.id)].levelName}}
            </span>
            <span v-else
              :class="'ignore pointer badge ' + permissionLevels[slotProps.data.permissionLevel].colourCode" 
            >
              {{ permissionLevels[slotProps.data.permissionLevel].levelName }}
            </span>
            <OverlayPanel 
              ref="levels" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="levels" 
              style="width: 180px"
            > 
              <div
                v-for="(val, index) in tempPermissionLevels"
                :key="index"
              >
                <span 
                  @click="updateLevel(val, slotProps.data)" 
                  :class="'ignore pointer badge ' + val.colourCode" 
                >
                  {{ val.levelName }}
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
          </template>
      </Column>
      <Column
        field="updatedBy.fullName"
        header="Updated By"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
            {{ slotProps.data.updatedBy && slotProps.data.updatedBy.fullName ? slotProps.data.updatedBy.fullName : '' }}
          </div>
        </template>
      </Column>
      <Column
        field="dateUpdated"
        header="Date"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.dateUpdated }}
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>

import RoleService from "@/service/RoleService";
import { sendPermission } from '../sendRequest'

export default {
  props: [
    'permissions',
    'loading',
    'up'
  ],
  data: () => ({
    roleService: new RoleService(),
    selectedRows: null,
    selectedRow: {},
    tempPermissionLevels: [],
    tempPermission: {},
    sendingRequest: false,
    role: {},
    permissionLevel: null,
    updatePermissions: [],
    permissionLevels: [
      {
        'id': 0,
        'levelName': "Don't Allow",
        'colourCode': 'badge-danger'
      },
      {
        'id': 1,
        'levelName': 'Allow',
        'colourCode': 'badge-success'
      },
      {
        'id': 2,
        'levelName': 'Allow excl. Locked Fields',
        'colourCode': 'badge-warning'
      },
      {
        'id': 3,
        'levelName': 'Allow for All fields',
        'colourCode': 'badge-primary'
      },
      {
        'id': 4,
        'levelName': 'Allow for All Branches',
        'colourCode': 'badge-info'
      },
      {
        'id': 5,
        'levelName': 'Allow for User Branch',
        'colourCode': 'badge-secondary'
      }
    ],
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  watch: {
    permissions(val) {
      this.updatePermissions = this.permissions.map(p => {
        return {
          id: p.id,
          permissionId: p.permission.id,
          permissionLevel: p.permissionLevel,
          roleId: p.roleId,
          userOrRole: p.userOrRole,
        }
      })
    },
    async up(val) {
      let counter = 0
      try {
        this.$emit('load')
        for(let i=0; i<this.permissions.length; i++ )
        {
          if(this.permissions[i].permissionLevel !== this.updatePermissions[i].permissionLevel)
          {
            ++counter
            await this.roleService.updatePermission(this.updatePermissions[i])
          }
        }
      }
      catch(e){
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: `Error while updating permission`,
          life: 5000,
        })
      } 
      finally{
        this.$emit('load')
        this.$emit('saved',{})
        this.$toast.add({
          severity: "success",
          summary: "Permissions Updated Successfully",
          detail: `${counter} permissions changes have been saved`,
          life: 5000,
        })
      }

    }
  },
  methods: {
    getUpdatedPermissionLevel(id) {
      let per = this.updatePermissions.find(p=> p.id === id)
      return per.permissionLevel
    },
    getButtons(data) {
      let buttons = []

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.$emit('delete-data',  data)
          }
        }
      )
      return buttons
    },
    editPermission(data) {
      if (data && data.id)
        this.$emit('edit-data',  data)
    },
    changeLevel(permission, event) {
    
      this.tempPermission = {...permission.permission}
      this.tempPermissionLevels = []

      // converting levels string "0,1,2" into array [0,1,2]
      let levels = this.tempPermission.possLevels.split(',')
      
      levels.forEach(level => {
        // if(permission.permissionLevel != level) {
          if(level === '0')
            this.tempPermissionLevels.push(this.permissionLevels[0])
          else if(level === '1')
            this.tempPermissionLevels.push(this.permissionLevels[1])
          else if(level === '2')
            this.tempPermissionLevels.push(this.permissionLevels[2])
          else if(level === '3')
            this.tempPermissionLevels.push(this.permissionLevels[3])
          else if(level === '4')
            this.tempPermissionLevels.push(this.permissionLevels[4])
          else if(level === '5')
            this.tempPermissionLevels.push(this.permissionLevels[5])
        // }
      });
           
      this.$refs.levels.toggle(event);
    },
    updateLevel(val, permission) {
      var per = null
      if(this.permissions && this.tempPermission) {
        per = this.permissions.find(p => p.permission && p.permission.permissionCode === this.tempPermission.permissionCode)
      }
      if(per){
        for(let i=0; i<this.updatePermissions.length; i++)
        {
          if(this.updatePermissions[i].id === per.id)
          {
            this.updatePermissions[i].permissionLevel = val.id
            this.$refs.levels.hide()
            return
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
    font-size: 14px;
}
</style>>

</style>